/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';
import { getTeamProfile } from '../services/team';
import { teamActions } from './definition';
import { ITeam } from '../interfaces/team';

function teamIsLoading() {
    return {
        type: teamActions.TEAM_IS_LOADING,
    };
}

const teamReset = () => {
    return {
        type: teamActions.TEAM_RESET,
    };
};

function teamSet(defys: any) {
    return {
        type: teamActions.TEAM,
        data: defys,
    };
}

function teamError(e: string) {
    return {
        type: teamActions.TEAM_ERROR,
        error: e,
        data: e,
    };
}

/**
 * Reducer to rest a teams
 * @param values Data to reset teams
 */
export const resetStateTeam = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(teamReset());
    };
};

/**
 * Reducer to get a team by id
 * @param id Id of team to find
 */
export const teamProfile = (sport: string) => {
    return async (dispatch: Dispatch<any>): Promise<ITeam> => {
        // console.log('getTeamProfile');
        dispatch(teamIsLoading());
        try {
            const response = await getTeamProfile(sport);
            const team = response.data;
            //   console.log({ team });
            //dispatch(teamSetTeam(response));
            return team;
        } catch (error: any) {
            dispatch(teamError('No se pudo obtener el team'));
        }
    };
};

/**
 * Reducer  answerChallenge team
 * @param values Data to create a answerChallenge team
 */
export const teamProfileGet = (sport: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(teamIsLoading());
            const response = await getTeamProfile(sport);
            dispatch(teamSet(response));
        } catch (error: any) {
            dispatch(teamError('No se pudo obtenet el team'));
        }
    };
};
